enum TipoFiltroBuscaEleitoresDocenteEnum {
  LOTACAO,
  LECIONANDO_DEPARTAMENTO,
  LECIONANDO_CURSO,
  EQUIPE_PROGRAMA,
  PERSONALIZADO,
}

export default TipoFiltroBuscaEleitoresDocenteEnum;
